module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container-fluid page-head-wrap"
  }, [_c('div', {
    staticClass: "container page-head"
  }, [_c('h3', {
    staticClass: "h4 text-center"
  }, [_c('b', [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[14][1]"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "offset-md-2 col-md-8 px-md-5"
  }, [_c('div', [_c('div', {
    staticClass: "form-wrap"
  }, [_c('div', {
    staticClass: "form-list py-2 px-3"
  }, [_c('div', {
    staticClass: "row pt-2 form-description-area"
  }, [_c('p', {
    staticClass: "col-12"
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[16][1]",
      "isHtml": true
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "col-12"
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[16][2]",
      "isHtml": true
    }
  })], 1)]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "offset-1 offset-lg-3 col-10 col-lg-6"
  }, [_c('div', {
    staticClass: "my-4"
  }, [_c('router-link', {
    staticClass: "btn w-100 btn-lg btn-default",
    attrs: {
      "tag": "button",
      "to": {
        name: 'top',
        params: {}
      }
    }
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[16][3]"
    }
  })], 1)], 1)])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 form-hr"
  }, [_c('hr', {})])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6036bd28!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/PasswordRemindComplete.vue
// module id = 707
// module chunks = 0